import React from 'react';
import { LanguageOption } from '../../types';

interface LanguageSelectorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: LanguageOption[];
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  label,
  value,
  onChange,
  options,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor={`lang-select-${label}`}
        className="font-semibold text-gray-700 text-sm"
      >
        {label}:
      </label>
      <select
        id={`lang-select-${label}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-4 py-2 border-2 border-gray-200 rounded-md text-base bg-white cursor-pointer transition-colors hover:border-primary-500 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-100"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;



